/**
 * @generated SignedSource<<41cf844e8a41ba92ddf25cc7ef876a4f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TimelineCellRenderer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TimelineCell" | "TimelineCell_AggregatedTimelineCell">;
  readonly " $fragmentType": "TimelineCellRenderer";
};
export type TimelineCellRenderer$key = {
  readonly " $data"?: TimelineCellRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimelineCellRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "TimelineCellRenderer",
  "selections": [
    {
      "condition": "isTimelineEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TimelineCell"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelinerollupstechnicalgaterelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TimelineCell_AggregatedTimelineCell"
        }
      ]
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "c1de1facc7b86a79d000f40f979013d6";

export default node;
